import React, { useState, useEffect } from 'react';
import './App.css';
import { buildScopedApiUrl, getApiHeaders } from "./config";
import { useWorkspace } from './workspace/WorkspaceContext';

const normalizeObjectPayload = (payload) => {
  if (payload && typeof payload === 'object' && !Array.isArray(payload)) return payload;
  if (payload?.data && typeof payload.data === 'object' && !Array.isArray(payload.data)) return payload.data;
  if (payload?.position && typeof payload.position === 'object' && !Array.isArray(payload.position)) return payload.position;
  return null;
};

function SignalPositionDetails({ signalRequestId, symbol, side, refreshTrigger, signalPositionrefreshTrigger }) {
  const { workspace } = useWorkspace();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let retryInterval;

    const fetchData = async () => {
      try {
        //setLoading(true);
        setError(null); // ✅ Clear previous error before fetching

        const response = await fetch(
          buildScopedApiUrl('/api/bot/ui/get/signalPositionDetails', workspace, {
            signalRequestId,
            symbol,
            side,
          }),
          {
            headers: getApiHeaders()
          }
        );
        if (!response.ok) {
          throw new Error('Failed to fetch data');
        }

        const text = await response.text();
        const parsed = text ? JSON.parse(text) : null;
        const normalized = normalizeObjectPayload(parsed);
        if (parsed && !normalized) {
          console.warn('Unexpected signal position payload shape', workspace, parsed);
        }
        setData(normalized);
        setError(null);
      } catch (error) {
        setError(error.message);

        // ✅ Retry fetching data every 5 seconds if API is down
        retryInterval = setTimeout(fetchData, 5000);
      } finally {
        setLoading(false);
      }
    };

    fetchData();

    return () => clearTimeout(retryInterval); // Cleanup on unmount
  }, [signalRequestId, symbol, side, refreshTrigger, signalPositionrefreshTrigger, workspace]);

  if (loading) return <div style={{ margin: '20px 0' }}>Loading...</div>;
  if (error) return <div style={{ margin: '20px 0', color: 'red' }}>Error: {error} (Retrying...)</div>;

  if (!data) return <div style={{ margin: '20px 0' }}>No signal position data for this workspace.</div>;

  const positionDetails = data;

  const getHoldSideHeaderStyle = () => ({
    color: positionDetails.holdSide === 'long' ? 'green' : 'red'
  });

  const getRowStyle = (value) => ({
    color: value && !isNaN(value) && value > 0 ? 'green' : 'red'
  });

  const getRowClassName = (value) => {
    if (!value || isNaN(value)) return '';
    return Number(value) > 0 ? 'green-row' : 'red-row';
  };
    

  return (
    <div className="mainContent">
      <table className="table">
        <thead>
          <tr>
            {Object.keys(positionDetails).map((key, index) => (
              <th key={`th-${index}`} scope="col"
               style={key === 'holdSide' ? getHoldSideHeaderStyle() : {}}
              > {key}
              </th>              
            ))}
          </tr>
        </thead>
        <tbody>
        <tr className={positionDetails.unrealizedPL > 0 ? 'positive' : 'negative'}>
    {Object.values(positionDetails).map((value, index) => (
      <td key={`td-${index}`}>{value !== null ? value.toString() : 'N/A'}</td>
    ))}
  </tr>
</tbody>

      </table>
    </div>
  );
}

export default SignalPositionDetails;

